module.exports = __webpack_public_path__ + "img/竹-素材.736bf0dd.svg";